require('./bootstrap');
window.Vue = require('vue');

const files = require.context('./', true, /\.vue$/i)

files.keys().map(key => {
  return Vue.component(_.last(key.split('/')).split('.')[0], files(key))
})

import VueRouter from 'vue-router'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://1c173828be16447e9224354e2e0a8f1a@sentry.io/1511093',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  });
}

Vue.component('multiselect', Multiselect)
Vue.component('datepicker', Datepicker)
Vue.use(VueRouter)

import router from './router'
import store from './store'

const app = new Vue({
  el: '#app',
  router,
  store,
});



// WEBPACK FOOTER //
// ./resources/js/app.js